import { render, staticRenderFns } from "./GFSettlementApprovalSection.vue?vue&type=template&id=26d3f879"
import script from "./GFSettlementApprovalSection.vue?vue&type=script&lang=js"
export * from "./GFSettlementApprovalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports